import { shuffle } from 'lodash'

const CHURN_SURVEY_RADIO_CHOICES = [
  {
    label: 'The price was too high for me.',
    value: 'price',
    children: randomizeChildren([
      {
        label: 'I loved using Segment but it’s too expensive.',
        value: 'price_expensive'
      },
      {
        label: 'I didn’t see the value given the price.',
        value: 'price_value'
      },
      {
        label: 'My Segment costs were increasing too quickly.',
        value: 'price_increasing_cost'
      },
      {
        label: 'I couldn’t understand Segment’s pricing.',
        value: 'price_confusion'
      }
    ])
  },
  {
    label: 'I had technical issues with the product and was not able to resolve them.',
    value: 'technical_issues',
    children: randomizeChildren([
      {
        label: 'Segment doesn’t work the way I expected.',
        value: 'product_expectations'
      },
      {
        label: 'I couldn’t figure out how to set Segment up properly.',
        value: 'product_setup'
      },
      {
        label: 'Segment didn’t work.',
        value: 'product_broken'
      },
      {
        label: 'I had a technical problem that Segment Support couldn’t resolve.',
        value: 'product_support'
      }
    ])
  },
  {
    label: 'This is not the right time for me to use Segment’s product.',
    value: 'timing',
    children: randomizeChildren([
      {
        label: 'We deprioritized this project indefinitely.',
        value: 'timing_deprioritized'
      },
      {
        label: 'I’ll be back when I’m ready to set things up with Segment.',
        value: 'timing_later'
      },
      {
        label: 'I’m no longer with the company that purchased Segment.',
        value: 'timing_new_company'
      }
    ])
  },
  {
    label: 'Segment does not have the features I want.',
    value: 'features',
    children: randomizeChildren([
      {
        label: 'Segment doesn’t have the integrations I want.',
        value: 'features_integrations'
      },
      {
        label: 'Segment doesn’t have the data sources I want.',
        value: 'features_sources'
      },
      {
        label: 'Segment doesn’t have the libraries or SDKs I want.',
        value: 'features_libraries'
      },
      {
        label: 'Segment doesn’t support the warehouses I want.',
        value: 'features_warehouses'
      }
    ])
  },
  {
    label: 'I have a different Segment workspace and no longer need this one.',
    value: 'other_workspace'
  }
]

function randomizeChildren (children) {
  const randomizedChildren = shuffle(children)
  randomizedChildren.push({ label: 'Other', value: 'other' })
  return randomizedChildren
}

const CHURN_CHOICES = shuffle(CHURN_SURVEY_RADIO_CHOICES)
CHURN_CHOICES.push({ label: 'Other', value: 'other' })

export default CHURN_CHOICES



// WEBPACK FOOTER //
// ./ui/ChurnSurveyConstants.js